import AppInnerTabs from './AppInnerTabs';
import MoreInnerTabsDropdown from './MoreInnerTabsDropdown';

export { MoreInnerTabsDropdown };

export default AppInnerTabs;
